import React from 'react';
import { useQuery, Loading, Error } from 'react-admin';
import jwt_decode from 'jwt-decode'
import RadioButtonGroup from  '../controls/RadioButtonGroup'

import HtmlToReact from 'html-to-react'
var HtmlToReactParser = HtmlToReact.Parser;
var htmlToReactParser = new HtmlToReactParser();

const Exam = ({examid, ...props}) => {
    //let cid = ((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).cid : '1'    
    //console.log(examid)
  
    const checkAnswer=(index, value, iscorrect)=>{
        console.log(index + ' -- ' + value + '--Is Correct? ' + iscorrect)
        if(answers.length >= index){
            answers[index] = value;
            marks[index] = iscorrect ? 1 : 0;
        }
        var cur_marks =  marks.reduce((a, v) => a + v, 0);
        var cur_percetage = (cur_marks/ marks.length) * 100.00
        ispass = (cur_percetage >= passing_percentage)? 1 : 0;
        props && props.setAnswers(answers);
        props && props.setMarkPer(cur_percetage);
        props && props.setPass(ispass);
        console.log('Marks: ' + cur_marks + '\npercetage: ' + cur_percetage + '%\nIs pass?: ' + ispass)
    }

    const { data, loading, error } = useQuery({ 
        type: 'getOne',
        resource: 'setupquestions',
        payload: { id: examid }
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    //console.log(data)
    var questions  = [];
    var answers =[];
    var marks = [];
    var ispass = 0;
    var passing_percentage = data && data.passing_percentage? data.passing_percentage : 100.00;

    if(data && data.question){
      try{
        questions =JSON.parse(data.question) 
      } catch(e) {
        questions = data.question;
      };
    }
    props && props.setQuestions(questions); 
    props && props.setPassingPer(data && data.passing_percentage);
    questions && questions.map((item, index) =>(
        answers.push(''),
        marks.push(0))
    )
    
    return(
        <div>
        {questions && questions.map((item, index) =>( 
            <p key={index}><font color="navy" size="2">
                 <span>{htmlToReactParser.parse(item['passage'])}</span>&nbsp;
                { index + 1})&nbsp;&nbsp;
                {
                    item['quest']
                }<br/></font>
              <RadioButtonGroup choices={item['Choices']} index={index} checkAnswer={checkAnswer} />
            </p>
        ))
        }
       </div>
      )
};

export default Exam